import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import base_url from '../../../api/bootapi'
import { Loader, Tabs } from '@mantine/core'
import {
  IconPlaneArrival,
  IconPlaneDeparture,
  IconRotateClockwise,
  IconTemperatureSun,
} from "@tabler/icons-react";
import moment from 'moment'
import FlightMap from '../FlightLiveTracking/FlightMap'
import FlightRouteCard from './FlightRouteCard'

const FlightStatsDetails = ({flightDetails,indivisualFlight}) => {



 
   const [flightData, setFlightData] = useState([]);
  const [airports, setAirports] = useState([]);
  
   const [toAirport, setToAirport] = useState([]);
    const [fromAirport, setFromAirport] = useState([]);
  const [flightStatus, setFlightStatus] = useState(null);
   const [currentFlightPosition, setCurrentFlightPosition] = useState([]);
    const [heading, setHeading] = useState(0);
    const [departureCode, setDepartureCode] = useState(null);
  const [arrivalCode, setArrivalCode] = useState(null);
  
    const [requestData, setRequestData] = useState(null);
    const [upcomingDates, setUpcomingDates] = useState([]);
    const [activeTab, setActiveTab] = useState(null);
  
  const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      if (airports.length > 0) {
        const toAirportIndex = airports.find(
          (airport) => airport.fs === arrivalCode
        );
  
        console.log("toAirportIndex", toAirportIndex);
        console.log("arrivalCode", arrivalCode);
  
        const fromAirportIndex = airports.find(
          (airport) => airport.fs === departureCode
        );
  
        if (toAirportIndex) {
          setToAirport(toAirportIndex);
        }
  
        if (fromAirportIndex) {
          setFromAirport(fromAirportIndex);
        }
  
        console.log("fromAirportIndex", fromAirportIndex);
        console.log("departureCode", departureCode);
      }
    }, [airports]);

  useEffect(() => {

    
      const handleViewMore = async(flightDetails) => {
  

   
          setFlightData(flightDetails?.appendix?.airports);
        const responseAirports = flightDetails?.appendix?.airports;

        console.log("Airport List ====== > ",responseAirports)
        if (responseAirports && responseAirports.length > 0) {
          const mappedAirports = responseAirports.map((airport) => ({
            ...airport,
            lat: airport.latitude,
            lng: airport.longitude,
          }));
        console.log("Mapped Airport List ====== > ",mappedAirports)

          setAirports(mappedAirports);
        } else {
          setAirports([]);
        }
  
        // const flightStatus = response?.data?.flight_status?.flightStatuses[0];
        // console.log(flightStatus);
        setFlightStatus("L");
  
        setDepartureCode(
          flightDetails?.flightTrack.departureAirportFsCode || null
        );
        setArrivalCode(
         flightDetails?.flightTrack.arrivalAirportFsCode || null
        );
  
        console.log("Departure Code =======> ", flightDetails?.flightTrack.departureAirportFsCode)
        console.log("Arrival Code =========>", flightDetails?.flightTrack.arrivalAirportFsCode)
        
      
       
        const currentFlightPosition =
          flightDetails?.flightTrack?.positions;
        const heading = flightDetails?.flightTrack?.heading || 0;
  
        console.log("Heading =========> ",heading)
        console.log("Flight Position ==========>  ",currentFlightPosition)
        setHeading(heading);
  


        setCurrentFlightPosition(currentFlightPosition);
        setLoading(false);
    
     
    
    


    };
    
    if (flightDetails) {
      
      handleViewMore(flightDetails)
    }
  }, [flightDetails])



    const dateFormat = (dateString) => {
    if (!dateString) return "";

    // Keep exactly as given (up to minutes)
    const trimmed = dateString.slice(0, 16);

    const [datePart, timePart] = trimmed.split("T");
    const [year, month, day] = datePart.split("-");
    const [hour, minute] = timePart.split(":");

    // Only for weekday/month name — no effect on time
    const tempDate = new Date(`${year}-${month}-${day}`);
    const weekday = tempDate.toLocaleDateString("en-GB", { weekday: "long" });
    const monthName = tempDate.toLocaleDateString("en-GB", { month: "short" });

    return {
      date: `${weekday}, ${day} ${monthName} ${year}`,
      time: `${hour}:${minute}`,
    };
  };

   function getDelayStatus(scheduled, actual) {
      console.log(scheduled, actual);
      if (
        scheduled === null ||
        scheduled === undefined ||
        scheduled === "" ||
        actual === null ||
        actual === undefined ||
        actual === ""
      ) {
        return (
          <span style={{ fontSize: "15px", color: "green", fontWeight: "600" }}>
            {" "}
            On time
          </span>
        );
      }
  
      const diffMinutes = moment(actual).diff(moment(scheduled), "minutes");
  
      let value, unit;
      if (Math.abs(diffMinutes) >= 60) {
        value = (Math.abs(diffMinutes) / 60).toFixed(1); // hours
        unit = "hr";
      } else {
        value = Math.abs(diffMinutes); // minutes
        unit = "m";
      }
  
      if (diffMinutes > 0) {
        return (
          <span style={{ fontSize: "15px", color: "red", fontWeight: "600" }}>
            {" "}
            {value}
            {unit} Delay
          </span>
        );
      } else if (diffMinutes < 0) {
        return (
          <span style={{ fontSize: "15px", color: "green", fontWeight: "600" }}>
            {" "}
            {value}
            {unit} Early
          </span>
        );
      } else {
        return (
          <span style={{ fontSize: "15px", color: "green", fontWeight: "600" }}>
            {" "}
            On time
          </span>
        );
      }
    }
    function formatMinutesToHours(minutes) {
    if (minutes === null || minutes === undefined) return null;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}h ${m}m`;
  }
  function getFlightDuration(flightDurations, status) {
    if (!flightDurations || typeof flightDurations !== "object") return null;

    const { scheduledBlockMinutes, blockMinutes, airMinutes } = flightDurations;

    let minutes = null;

    if (status === "S" || status === "A") {
      // Scheduled or In Air
      minutes = scheduledBlockMinutes ?? airMinutes ?? null;
    } else if (status === "L") {
      // Landed
      minutes = blockMinutes ?? scheduledBlockMinutes ?? airMinutes ?? null;
    } else {
      // Fallback
      minutes = scheduledBlockMinutes ?? blockMinutes ?? airMinutes ?? null;
    }

    return formatMinutesToHours(minutes);
  }


   function getFlightStage(operationalTimes, status) {
    let stage = "Scheduled";
    let color = "#2B9950"; // default grey

    // Priority: use status if it's clear
    switch (status) {
      case "S":
        stage = "Scheduled";
        color = "#2B9950"; // grey
        break;
      case "A":
        stage = "Departed";
        color = "#DC3532"; // blue
        break;
      case "L":
        stage = "Arrived";
        color = "#28a745"; // green
        break;
      case "C":
        stage = "Cancelled";
        color = "#dc3545"; // red
        break;
      case "D":
        stage = "Diverted";
        color = "#ff9800"; // orange
        break;
      case "R":
        stage = "Redirected";
        color = "#ff9800"; // orange
        break;
      case "U":
        stage = "Unknown";
        color = "#6c757d"; // dark grey
        break;
      default:
        // If status isn't enough, check actual times
        if (
          operationalTimes?.actualRunwayArrival?.dateUtc ||
          operationalTimes?.actualGateArrival?.dateUtc
        ) {
          stage = "Arrived";
          color = "#28a745";
        } else if (
          operationalTimes?.actualRunwayDeparture?.dateUtc ||
          operationalTimes?.actualGateDeparture?.dateUtc
        ) {
          stage = "Departed";
          color = "#17a2b8"; // teal
        }
        break;
    }

    return (
      <span
        style={{
          padding: "4px 8px",
          borderRadius: "4px",
          backgroundColor: color,
          color: "#fff",
          fontWeight: "bold",
          fontSize: "0.9rem",
        }}
      >
        {stage}
      </span>
    );
  }


   function getPastTimeDiffReadable(utcDateString) {
      const target = moment.utc(utcDateString);
      const now = moment.utc();
  
      let diffMinutes = now.diff(target, "minutes");
  
      if (diffMinutes < 1) {
        return "Just now";
      }
  
      if (diffMinutes < 60) {
        return `${diffMinutes} minutes ago`;
      }
  
      let diffHours = now.diff(target, "hours");
      if (diffHours < 24) {
        return `${diffHours} hours ago`;
      }
  
      let diffDays = now.diff(target, "days");
      return `${diffDays} days ago`;
    }
  return (
    <div>


      
                {loading && (
                  <div className="loading-div">
                    <Loader />
                  </div>
                )}
      
                {!loading && airports.length === 0 && (
                  <div
                    className="no-data-found"
                    style={{ marginTop: "40px", textAlign: "center" }}
                  >
                    <p>No flight data found</p>
                  </div>
                )}
      
                {!loading && airports.length > 0 && (
                  <div
                    className="flight-data-container"
                    style={{ marginTop: "40px", }}
                  >
                   
                  
            
          
          <FlightRouteCard flight={indivisualFlight} viewMore={false} />
      
                    <div className="flight-data-refresh-wrapper">
                      {currentFlightPosition.length > 0 ? (
                        <span className="last-updated">
                          Updated{" "}
                          {getPastTimeDiffReadable(currentFlightPosition[0]?.date)}{" "}
                        </span>
                      ) : (
                        <span></span>
                      )}
      
                      {/* <span
                        className="refresh-btn"
                        onClick={() => fetchFlightData(requestData)}
                      >
                        <IconRotateClockwise size={"13px"} /> Refresh
                      </span> */}
          </div>
          

          {
            currentFlightPosition && currentFlightPosition.length > 0 &&  <FlightMap
                      airports={airports}
                      currentFlightPosition={currentFlightPosition}
                      heading={heading}
                    />
          }
                   
                  </div>
                )}
    </div>
  )
}

export default FlightStatsDetails